/** Cosmetic, client-side-only slug for display (not a persisted identifier). */
function slugPart(value: string): string {
  return value
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

/** "SHOW-CRIMSON-HARBOUR" from a show name. */
export function showSlug(showName: string): string {
  return `SHOW-${slugPart(showName)}`;
}

/** "SHOW-CRIMSON-HARBOUR-S01-THE-TIDE-TURNS" from a show name + season code/name. */
export function seasonSlug(
  showName: string,
  seasonCode: string,
  seasonName?: string | null,
): string {
  const suffix = [seasonCode, seasonName].filter((part): part is string => Boolean(part)).join('-');
  return `${showSlug(showName)}-${slugPart(suffix)}`;
}
